import angular from 'angular';
import PayseraConfig from './paysera-config';

export default angular
    .module('paysera.config.services', [])
    .service('payseraConfig', PayseraConfig)
    .name
;
